import { ChangeDetectorRef, Injectable } from '@angular/core';
import { act, Actions, createEffect, ofType } from '@ngrx/effects';
import {
  map,
  catchError,
  tap,
  exhaustMap,
  filter,
} from 'rxjs/operators';
import { of } from 'rxjs';
import * as fromAddressActions from '../actions/address.action';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { setLoadingSpinner } from '../actions/shared.action';
import { ModalService } from 'src/app/services/modal.service';
import { ROUTER_NAVIGATION, RouterNavigatedAction } from '@ngrx/router-store';
import { AddressService } from 'src/app/services/address.service';

@Injectable()
export class AddressEffects {

  getRegions$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r : RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/home/application') 
        || r.payload.routerState.url.startsWith('/home/edit-application');
      }),
      exhaustMap((action) => 
        this.addressService.getRegions().pipe(
          map((response)=>{
            console.log('getRegions$', response);
            return fromAddressActions.getRegionsSuccess({data: response})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromAddressActions.getRegionsFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );

  getProvinces$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(fromAddressActions.getProvinces),
      exhaustMap((action) => 
        this.addressService.getProvinces(action?.regCode).pipe(
          map((response)=>{
            console.log('getProvinces$', response);
            return fromAddressActions.getProvincesSuccess({data: response})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromAddressActions.getProvincesFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );

  getCities$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(fromAddressActions.getCities),
      exhaustMap((action) => 
        this.addressService.getCities(action?.provCode).pipe(
          map((response)=>{
            console.log('getCities$', response);
            return fromAddressActions.getCitiesSuccess({data: response})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromAddressActions.getCitiesFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );

  getBarangays$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(fromAddressActions.getBarangays),
      exhaustMap((action) => 
        this.addressService.getBarangays(action?.cityCode).pipe(
          map((response)=>{
            console.log('getBarangays$', response);
            return fromAddressActions.getBarangaysSuccess({data: response})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromAddressActions.getBarangaysFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private addressService: AddressService,
    private modalService: ModalService
  ) {}
}
